module.exports = __webpack_public_path__ + "img/download_android.f64865e6.png";